var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCensorshipresistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 44,
    viewBox: "0 0 89 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 22C87 22 67.9315 42 44.4954 42C21.0594 42 2 22 2 22C2 22 21.0685 2 44.4954 2C67.9224 2 87 22 87 22Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9046 41.5317C54.8976 41.5317 63.8092 32.7642 63.8092 21.949C63.8092 11.1337 54.8976 2.36621 43.9046 2.36621C32.9116 2.36621 24 11.1337 24 21.949C24 32.7642 32.9116 41.5317 43.9046 41.5317Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9047 6.93555V36.3913",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8746 21.6636H28.9347",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4893 32.0771L33.3199 11.25",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3199 32.0771L54.4893 11.25",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9047 26.7018C46.7675 26.7018 49.0882 24.4186 49.0882 21.6021C49.0882 18.7856 46.7675 16.5024 43.9047 16.5024C41.0419 16.5024 38.7212 18.7856 38.7212 21.6021C38.7212 24.4186 41.0419 26.7018 43.9047 26.7018Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCensorshipresistant);
export default __webpack_public_path__ + "static/media/censorshipresistant.43080236d5a1dc93ece19ac0839fc40f.svg";
export { ForwardRef as ReactComponent };